import { IRefIds } from 'constants/refs';
import { get } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { ITranslationProjectTranslationItem } from 'types/translationProject';

export default class TranslationProjectTranslationItemsModel extends BaseModel<ITranslationProjectTranslationItem, null> {
  projectId?: number;

  constructor(options: IModelOptions & { projectId?: number }) {
    super(options);
    this.projectId = options.projectId;
    this.ref = IRefIds.translation;
    this.gridName = 'TranslationProjectTranslationItems';
    this.getGridColumns();
  }

  setProjectId(projectId: number) {
    this.projectId = projectId;
    this.gridData = [];
    this.getGrid();
  }

  async getGrid() {
    if (!this.projectId) return;

    await super.getGrid();
    this.gridData = await get<ITranslationProjectTranslationItem[]>(
      `/translations/projects/${this.projectId}/translations`,
    );
    this.loadingGrid = false;
    this.render();
  }

  async refresh() {
    await this.getGrid();
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async loadItemData(itemId: number) {
    return {};
  }

  async getGridRow(itemId: number) {
    // Items don't have individual endpoints, find from grid data
    const item = this.gridData?.find((i: ITranslationProjectTranslationItem) => i.id === itemId);
    return item || { id: itemId };
  }
}
